import { useContext } from "react";
import { BsPerson } from "react-icons/bs";
import { GoLocation } from "react-icons/go";
import { FaRegClock } from "react-icons/fa";
import Context from "../../../../Context";
import calculateAge from "../../../../controllers/calculateAge";
import { MdOutlineWorkOutline } from "react-icons/md";
import CardForItem from "../../../customUiForCs/CardForItem";
import parseDate from "../../../../controllers/parseDate";

export default function UserActivityCard({ data }) {
  console.log("data", data);
  const {} = useContext(Context);

  let image = null;
  let title = null;
  let line1 = null;
  let line2 = null;
  let absolutePath = null;

  if (data.user) {
    image = data.user.profileImage;
    title = `${data.user.lastName} ${data.user.firstName}`;
    let info = getInfo();
    line1 = [{ text: info.line1 }];
    line2 = [{ text: info.line2 }];
    absolutePath = info.link;
  }

  return (
    <CardForItem
      absolutePath={absolutePath}
      itemID={data._id}
      // image={image}
      title={title}
      bubbleTexts={[
        `${convertToFrenchPastTense(data.actionType)} → ${data.subjectType.toLowerCase()}`,
      ]}
      line1={line1}
      line2={line2}
    />
  );

  function convertToFrenchPastTense(action) {
    const actionMap = {
      CREATE: "créé",
      UPDATE: "mis à jour",
      VIEW: "vu",
      DELETE: "supprimé",
    };

    return actionMap[action] || "Action inconnue";
  }

  function getInfo() {
    if (!data.itemDoc) return { line1: null, line2: null, link: null };

    let itemDoc = data.itemDoc;

    if (data.subjectType == "PROFILE") {
      return {
        line1: `${itemDoc.lastName} ${itemDoc.firstName}`,
        line2: `${itemDoc.accountType?.toLowerCase()}`,
        link: `/employee/${itemDoc._id}`,
      };
    } else if (data.subjectType == "DAILY_RESPONSIBILITY") {
      return {
        line1: `Presentation du Staff Journalier`,
      };
    } else if (data.subjectType == "SITE") {
      return {
        line1: `${itemDoc.placeName} ${itemDoc.clientName}`,
        line2: `${itemDoc.addressLocality}`,
        link: `/site/${itemDoc._id}`,
      };
    } else if (data.subjectType == "ROLE") {
      return {
        line1: `${itemDoc.name}`,
        line2: `${itemDoc.description}`,
        link: `/employee/${itemDoc._id}`,
      };
    } else if (data.subjectType == "ZONE") {
      return {
        line1: `${itemDoc.name}`,
        line2: `${itemDoc.description}`,
        link: `/zone/${itemDoc._id}`,
      };
    } else if (data.subjectType == "ABSENCE") {
      return {
        line1: `${parseDate(itemDoc.startDate)}-${parseDate(itemDoc.endDate)}`,
        line2: `${itemDoc.note}`,
        link: `/employee/${itemDoc.userID}`,
      };
    } else if (data.subjectType == "VACATION") {
      return {
        line1: `${parseDate(itemDoc.startDate)} ${parseDate(itemDoc.endDate)}`,
        line2: `${itemDoc.note}`,
        link: `/employee/${itemDoc.userID}`,
      };
    } else if (data.subjectType == "DISPUTE") {
      return {
        line1: `${itemDoc.reason}`,
        line2: `${itemDoc.response}`,
        link: `/employee/${itemDoc.userID}`,
      };
    } else if (data.subjectType == "COMMENT") {
      return {
        line1: `${itemDoc.text}`,
        line2: ``,
        link: `/employee/${itemDoc.subjectID}`,
      };
    }
  }
}
